import * as actionTypes from './action-types';

const initialState = {
    assignedTasksId: [],
    showAssignErrorModal: false,
    showSaveErrorModal: false,
    showAssignErrorToast: false,
    showAssignSuccessToast: false,
    activateModal: false,
    assigningCourses: false,
    isAssignEvent: false,
    isCourseModalVisible: false
};

export default function (state = initialState, action) {
    switch (action.type) {
    case actionTypes.GET_ADMIN_DEFAULT_COURSE_FAILURE: {
        return { ...state };
    }
    case actionTypes.GET_ADMIN_DEFAULT_COURSE_SUCCESS: {
        return { ...state, defaultCourses: action.data };
    }
    case actionTypes.GET_ADMIN_DEFAULT_COURSE_REQUEST: {
        return { ...state };
    }
    case actionTypes.CHECK_COMMON_TASKS_SUCCESS: {
        return { ...state,
            assignedTasksId: action.assignedTasksId,
            activateModal: action.assignedTasksId.length > 0,
            isAssignEvent: true
        };
    }
    case actionTypes.SET_ASSIGN_UPF_COURSE: {
        return { ...state, isAssignEvent: true, upfCourseId: action.payload.id };
    }

    case actionTypes.SET_ASSIGN_NEW_COURSE: {
        return { ...state, isAssignEvent: true, conquestCourseId: action.payload.id };
    }
    case actionTypes.CHECK_COMMON_TASKS_FAILURE: {
        return { ...state, showAssignErrorModal: true, activateModal: true
        };
    }
    case actionTypes.CANCEL_ASSIGN_REQUEST: {
        return { ...state, isAssignEvent: false
        };
    }
    case actionTypes.ACTIVATE_MODAL_REQUEST: {
        return { ...state, activateModal: true
        };
    }
    case actionTypes.DEACTIVATE_MODAL_REQUEST: {
        return { ...state, activateModal: false
        };
    }
    case actionTypes.ASSIGN_COURSES_REQUEST: {
        return { ...state, assigningCourses: true
        };
    }
    case actionTypes.ASSIGN_COURSES_SUCCESS: {
        return {
            ...state,
            assigningCourses: action.assigningCourses,
            showAssignSuccessToast: true
        };
    }
    case actionTypes.ASSIGN_COURSES_FAILURE: {
        return {
            ...state,
            assigningCourses: action.assigningCourses,
            showSaveErrorModal: false,
            showAssignErrorToast: true,
            activateModal: false
        };
    }
    case actionTypes.RESET_TOASTER_STATE: {
        return { ...state,
            showAssignSuccessToast: false,
            showAssignErrorToast: false
        };
    }
    case actionTypes.SHOW_COURSE_DETAILS: {
        return { ...state, selectedCourseId: action.courseId };
    }
    case actionTypes.HIDE_COURSE_DETAILS: {
        return { ...state, courseDetails: initialState.courseDetails, selectedCourseId: false, isCourseModalVisible: false };
    }
    case actionTypes.FETCH_COURSE_DETAILS_REQUEST: {
        return { ...state, fetchingCourse: true };
    }
    case actionTypes.FETCH_COURSE_DETAILS_SUCCESS: {
        return { ...state, courseDetails: action.courseDetails, fetchingCourse: false, isCourseModalVisible: true };
    }
    case actionTypes.FETCH_COURSE_DETAILS_FAILURE: {
        return { ...state, fetchingCourse: false };
    }
    case actionTypes.GET_NEW_COURSES_REQUEST: {
        return {
            ...state,
            isNewCoursesFetching: action.isNewCoursesFetching
        };
    }

    case actionTypes.GET_NEW_COURSES_SUCCESS: {
        return {
            ...state,
            newCourses: action.data,
            isNewCoursesFetching: false
        };
    }

    case actionTypes.GET_NEW_COURSES_FAILURE: {
        return {
            ...state,
            newCourses: [],
            isNewCoursesFetching: false
        };
    }
    default:
        return { ...state };
    }
}



// WEBPACK FOOTER //
// ./app/containers/manage-assigned-courses/reducer.js